<!-- Loading -->
@if (loading) {
  <div class="sc-loading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
}

@if (!loading) {

  <!-- Hero de confirmación -->
  <section class="sc-hero">
    <div class="container">
      <div class="sc-hero-inner">
        <div class="sc-check">
          <mat-icon>check</mat-icon>
        </div>
        <div class="sc-hero-text">
          <h1 class="sc-title">{{ 'success.thankyou' | translate }}</h1>
          <p class="sc-sub">{{ 'success.orderSuccefully' | translate }}</p>
        </div>
        <div class="sc-order-badge">
          <span class="sc-order-label">{{ 'success.ordernro' | translate }}</span>
          <span class="sc-order-num">#{{ basketOrder.id }}</span>
          <span class="sc-order-date">{{ basketOrder.open | date: 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Detalle del pedido -->
  <section class="sc-section">
    <div class="container">
      <div class="sc-receipt">

        <!-- Franja verde tope -->
        <div class="sc-receipt-header">
          <span>{{ 'success.orderdetail' | translate }}</span>
        </div>

        <div class="row sc-receipt-body">

          <!-- Ítems -->
          <div class="col-lg-8 sc-items-col">
            <table class="sc-table">
              <thead>
                <tr>
                  <th class="sc-th sc-th--name">{{ 'cart-table.product-name' | translate }}</th>
                  <th class="sc-th sc-th--qty">{{ 'cart-table.quantity' | translate }}</th>
                  <th class="sc-th sc-th--price">{{ 'cart-table.price' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (basketItem of basketOrder.items; track basketItem) {
                  <tr class="sc-row">
                    <td class="sc-td sc-td--name">{{ articleService.getArticleName(basketItem.item) }}</td>
                    <td class="sc-td sc-td--qty">{{ basketItem.quantity }}</td>
                    <td class="sc-td sc-td--price">{{ articleService.getPriceToShow(basketItem.unitPrice) | currency }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr class="sc-total-row">
                  <td colspan="2" class="sc-td sc-total-label">{{ 'cart-table.total' | translate }}</td>
                  <td class="sc-td sc-total-value">{{ totalOrder | currency }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          <!-- Resumen lateral -->
          <div class="col-lg-4 sc-summary-col">

            <div class="sc-summary-block sc-summary-block--total">
              <span class="sc-summary-label">{{ 'cart-table.total' | translate }}</span>
              <span class="sc-summary-total">{{ totalOrder | currency }}</span>
            </div>

            <div class="sc-summary-block">
              <span class="sc-summary-label">{{ 'cart-table.billed-to' | translate }}</span>
              <div class="sc-summary-address">
                @if (basketOrder.customerDelivery.name || basketOrder.customerDelivery.lastName) {
                  <p class="sc-addr-name">
                    {{ basketOrder.customerDelivery.name }} {{ basketOrder.customerDelivery.lastName }}
                  </p>
                }
                @if (basketOrder.customerDelivery.cellphone) {
                  <p>{{ basketOrder.customerDelivery.cellphone }}</p>
                }
                @if (basketOrder.customerDelivery.address) {
                  <p>{{ basketOrder.customerDelivery.address }}</p>
                }
                @if (basketOrder.customerDelivery.city) {
                  <p>
                    {{ basketOrder.customerDelivery.city }}
                    @if (basketOrder.customerDelivery.zipCode) {
                      ({{ basketOrder.customerDelivery.zipCode }})
                    }
                  </p>
                }
              </div>
            </div>

            <div class="sc-summary-block">
              <div class="sc-meta-row">
                <span class="sc-meta-label">{{ 'success.ordernro' | translate }}</span>
                <span class="sc-meta-val">#{{ basketOrder.id }}</span>
              </div>
              <div class="sc-meta-row">
                <span class="sc-meta-label">{{ 'success.orderdate' | translate }}</span>
                <span class="sc-meta-val">{{ basketOrder.open | date: 'dd/MM/yyyy' }}</span>
              </div>
            </div>

            <button class="sc-btn-back" [routerLink]="['/']">
              <mat-icon>arrow_back</mat-icon>
              {{ 'back' | translate }}
            </button>

          </div>
        </div>

      </div>
    </div>
  </section>

}
